export const UTM_ATTRIBUTE_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_adset',
  'utm_term',
  'utm_content',
  'campaign_id',
  'adset_id',
  'content_id',
  'ad_id',
  'utm_channel',
  'utm_matchtype',
];

export const PIXEL_ATTRIBUTE_KEYS = [
  'fbclid',
  'gclid',
  'ctwa_clid',
  'lead_id',
  'gbraid',
  'wbraid',
  'fbc',
  'fbp',
  'client_ip_address',
  'client_user_agent',
  'event_id',
  'ga_client_id',
];

export const SENSITIVE_ATTRIBUTE_KEYS = ['client_ip_address'];

export const SOURCE_ATTRIBUTE_KEYS = [
  ...UTM_ATTRIBUTE_KEYS,
  ...PIXEL_ATTRIBUTE_KEYS,
];
